import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { fadeAnimation } from 'src/app/app.animation';
import { PromiseService } from 'src/app/service/util/promise.service';
import { UserService } from 'src/app/service/basic/user.service';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  animations: [ fadeAnimation ],
})
export class IntroComponent implements OnInit, AfterViewInit {
  @HostBinding("slot") get slot() { return "fixed" };

  @Output() animationEnd:EventEmitter<null> = new EventEmitter();

  animationStep:number = 0;

  constructor(
    private el: ElementRef<HTMLElement>,
    public user: UserService,
    private promise: PromiseService
  ) { }

  ngOnInit() {}
  ngAfterViewInit() {
    this.animationRun();
  }
  
  private async animationRun() {
    await this.promise.wait(0);
    this.animationStep = 1;
    await this.promise.wait(50);
    this.animationStep = 2;
    await this.promise.wait(50);
    this.animationStep = 3;
    await this.promise.wait(1200);
    this.animationStep = 4;
    await this.promise.wait(160);
    this.animationEnd.emit();
    await this.promise.wait(200);
    this.el.nativeElement.remove();
  }
}